const simplifyQuestions = (questions) => {
  const result = {};

  for (const [key, value] of Object.entries(questions)) {
    if (value?.questionData?.value !== undefined) {
      result[key] = value.questionData.value;
    }
  }

  return result;
};

export default simplifyQuestions;
